import React, { HTMLAttributes, useEffect, useRef, useState } from "react";
import { AiOutlineLoading } from "react-icons/ai";
import { LuArrowLeft, LuArrowRight } from "react-icons/lu";

// import required modules
import { twMerge } from "tailwind-merge";
import {
  PARKING_NAME_EN_MAP,
  REGION_DISTRICT_MAP,
  REGION_LIST,
  STATION_INFO_MAP,
} from ".";
import { getEVInfo } from "../../../apis/parkingbeesRelatedService";
import type { IParkingBeesEvChargerVacancyResponse } from "../../../apis/parkingbeesRelatedService/type";

interface IEvInfoSwiperMobile {
  goNextSection: () => void;
}

type TEvInfoSwiperMobileProps = IEvInfoSwiperMobile &
  HTMLAttributes<HTMLDivElement>;

const EvInfoSwiperMobile: React.FC<TEvInfoSwiperMobileProps> = (props) => {
  const { goNextSection, ...otherProps } = props;
  const [selectedRegion, setSelectedRegion] = useState<string>("all");
  const [isInited, setIsInited] = useState<boolean>(false);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const [loadingMap, setLoadingMap] = useState<Record<string, boolean>>({});
  const [showPricing, setShowPricing] = useState(false);

  const [evInfoList, setEvInfoList] = useState<
    IParkingBeesEvChargerVacancyResponse[]
  >([]);
  const listRef = useRef<HTMLDivElement>(null);

  function filterByRegion(
    list: IParkingBeesEvChargerVacancyResponse[] = [],
    regionKey: string,
  ) {
    if (!Array.isArray(list)) return [];
    if (regionKey === "all") return list;
    const districtIds = REGION_DISTRICT_MAP[regionKey] || [];
    return list.filter((item) =>
      districtIds.includes(item.parking.district_id),
    );
  }

  const fetchAllEVInfo = async () => {
    try {
      const evInfoResponse = await getEVInfo();

      setEvInfoList(evInfoResponse);
      // setEvInfoList([
      //   {
      //     ms_token: "9811afa4-04ba-4a6b-9bdf-cad0b6b307af",
      //     parking: {
      //       id: 6,
      //       car_park_id: "499bc9f7-aabd-41ec-896a-da0668b7f95d",
      //       name: "荃灣",
      //       display_name: "國際企業中心三期",
      //       district_id: 16,
      //       short_name: "TW-IEC3",
      //       floor_plan: null,
      //       location: "白田壩街53號",
      //       location_en:
      //         "18 Tai Chung Road, International Enterprise Center, Tsuen Wan, NT",
      //       image_url:
      //         "https://s3.ap-southeast-1.amazonaws.com/booking.parkingbees.com.hk/parking_cover/tsuen_wan.jpeg",
      //       map: "https://www.google.com/maps/@22.3744099,114.1106455,3a,75y,196.14h,93.69t/data=!3m6!1e1!3m4!1soOrefyXkNLyprq7uv3xgaA!2e0!7i16384!8i8192?entry=ttu",
      //       quota: 78,
      //       cover:
      //         "https://parkingbees-global-images.s3.ap-southeast-1.amazonaws.com/tsuen_wan.png",
      //       description: null,
      //       visible: true,
      //       deleted: false,
      //       createdAt: "2024-06-18T11:23:51.909Z",
      //       updatedAt: "2025-09-28T11:08:30.025Z",
      //       hourly_rental_weekday: 22,
      //       hourly_rental_weekend: 29,
      //       hourly_rental_weekday_remark: "星期一至五(非公眾假期)",
      //       hourly_rental_weekend_remark: "星期六、日及公眾假期",
      //       daily_rental_weekday: 150,
      //       daily_rental_weekend: 150,
      //       daily_rental_weekday_remark: null,
      //       daily_rental_weekend_remark: null,
      //       night_rental_weekday: 60,
      //       night_rental_weekend: 60,
      //       night_rental_weekday_remark: "19:00 - 08:00\n(13-HR)",
      //       night_rental_weekend_remark: "19:00 - 08:00\n(13-HR)",
      //       gallery_images: "1749640424119.jpeg",
      //     },
      //     availableCount: 1,
      //     totalCount: 4,
      //     estimatedWaitingTime: 3,
      //   },
      //   {
      //     ms_token: "7vk4cv8g-8g2s-6k8f-49hk-ghb2kdss3lm2",
      //     parking: {
      //       id: 12,
      //       car_park_id: "1e9b2418-9d41-4f1c-aefb-d96eb7cf0061",
      //       name: "火炭",
      //       display_name: "星凱堤岸",
      //       district_id: 14,
      //       short_name: "ARLES",
      //       floor_plan: null,
      //       location: "火炭坳背灣街1號",
      //       location_en: "1 Au Pui Wan Street, Fo Tan, NT",
      //       image_url:
      //         "https://s3.ap-southeast-1.amazonaws.com/booking.parkingbees.com.hk/parking_cover/fo_tan.png",
      //       map: "https://www.google.com/maps/place/星凱‧堤岸/@22.3957956,114.197149,1027m/data=!3m2!1e3!4b1!4m6!3m5!1s0x34040f3887044537:0x1192c6a19dc99f77!8m2!3d22.3957956!4d114.197149!16s%2Fg%2F11rd2nj8x1?entry=ttu&g_ep=EgoyMDI1MDUyNy4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
      //       quota: 35,
      //       cover:
      //         "https://parkingbees-global-images.s3.ap-southeast-1.amazonaws.com/fo_tan.png",
      //       description: null,
      //       visible: true,
      //       deleted: false,
      //       createdAt: "2025-01-23T04:07:06.906Z",
      //       updatedAt: "2025-09-28T11:10:12.069Z",
      //       hourly_rental_weekday: null,
      //       hourly_rental_weekend: null,
      //       hourly_rental_weekday_remark: null,
      //       hourly_rental_weekend_remark: null,
      //       daily_rental_weekday: null,
      //       daily_rental_weekend: null,
      //       daily_rental_weekday_remark: null,
      //       daily_rental_weekend_remark: null,
      //       night_rental_weekday: null,
      //       night_rental_weekend: null,
      //       night_rental_weekday_remark: null,
      //       night_rental_weekend_remark: null,
      //       gallery_images:
      //         "1749611733858.jpeg,1749641541633.jpeg,1753259165665.jpg,1753259175411.jpg,1753259183459.jpg,1753259190394.jpg,1753259196394.jpg",
      //     },
      //     availableCount: 0,
      //     totalCount: 0,
      //     estimatedWaitingTime: null,
      //   },
      //   {
      //     ms_token: "bbfb0f5b-116a-6k8f-825b-8135311d9efb",
      //     parking: {
      //       id: 13,
      //       car_park_id: "5225770e-1be6-402a-946a-cbe2275225d6",
      //       name: "觀塘",
      //       display_name: "The MOD",
      //       district_id: 7,
      //       short_name: "MOD",
      //       floor_plan: null,
      //       location: "香港九龍觀塘偉業街207號",
      //       location_en: "162 Wai Yip Street, Kwun Tong, KLN",
      //       image_url:
      //         "https://s3.ap-southeast-1.amazonaws.com/booking.parkingbees.com.hk/parking_cover/the_mod.jpeg",
      //       map: "https://www.google.com/maps/place/THE+MOD/data=!4m2!3m1!1s0x0:0x33dec81c703e388c?sa=X&ved=1t:2428&ictx=111",
      //       quota: 20,
      //       cover:
      //         "https://parkingbees-global-images.s3.ap-southeast-1.amazonaws.com/the_mod.png",
      //       description: null,
      //       visible: true,
      //       deleted: false,
      //       createdAt: "2025-06-09T04:07:06.906Z",
      //       updatedAt: "2025-09-28T11:08:20.872Z",
      //       hourly_rental_weekday: null,
      //       hourly_rental_weekend: null,
      //       hourly_rental_weekday_remark: null,
      //       hourly_rental_weekend_remark: null,
      //       daily_rental_weekday: null,
      //       daily_rental_weekend: null,
      //       daily_rental_weekday_remark: null,
      //       daily_rental_weekend_remark: null,
      //       night_rental_weekday: null,
      //       night_rental_weekend: null,
      //       night_rental_weekday_remark: null,
      //       night_rental_weekend_remark: null,
      //       gallery_images: "1749466620807.png,1749466628358.png",
      //     },
      //     availableCount: 0,
      //     totalCount: 2,
      //     estimatedWaitingTime: 11,
      //   },
      //   {
      //     ms_token: "5806142a-8b73-42ae-8d33-2eea173ecccb",
      //     parking: {
      //       id: 2,
      //       car_park_id: "90e74191-2aad-4552-b324-c2bff00e69ed",
      //       name: "大角咀",
      //       display_name: "宏創坊",
      //       district_id: 9,
      //       short_name: "TKT-KHORA",
      //       floor_plan: null,
      //       location: "大角咀必發道128號",
      //       location_en: "128 Bedford Road, Khora, Tai Kok Tsui, KLN",
      //       image_url:
      //         "https://s3.ap-southeast-1.amazonaws.com/booking.parkingbees.com.hk/parking_cover/tai_kok_tsui.jpeg",
      //       map: "https://www.google.com/maps/place/AI+Parking+Bees+%E6%99%BA%E8%83%BD%E5%81%9C%E8%BB%8A%E5%A0%B4%EF%BC%8D%E5%A4%A7%E8%A7%92%E5%92%80/@22.3241317,114.1618777,19z/data=!3m1!4b1!4m6!3m5!1s0x34040145e6f5e31f:0x42b9c9f98f7e90ea!8m2!3d22.3241305!4d114.1625214!16s%2Fg%2F11stlppyl0?entry=ttu",
      //       quota: 14,
      //       cover:
      //         "https://parkingbees-global-images.s3.ap-southeast-1.amazonaws.com/tai_kok_tsui.png",
      //       description: null,
      //       visible: true,
      //       deleted: false,
      //       createdAt: "2024-06-07T13:11:30.389Z",
      //       updatedAt: "2025-09-28T11:08:42.620Z",
      //       hourly_rental_weekday: 28,
      //       hourly_rental_weekend: 28,
      //       hourly_rental_weekday_remark: null,
      //       hourly_rental_weekend_remark: null,
      //       daily_rental_weekday: 160,
      //       daily_rental_weekend: 160,
      //       daily_rental_weekday_remark: "0800-1800(10HR)",
      //       daily_rental_weekend_remark: "0800-1800(10HR)",
      //       night_rental_weekday: 90,
      //       night_rental_weekend: 90,
      //       night_rental_weekday_remark: "1800-0800(14HR)",
      //       night_rental_weekend_remark: "1800-0800(14HR)",
      //       gallery_images: "1729661458428.jpg",
      //     },
      //     availableCount: 1,
      //     totalCount: 2,
      //     estimatedWaitingTime: 35,
      //   },
      //   {
      //     ms_token: "c5d8f3a1-5b70-4e29-9f4b-2c8d1a7e6b3f",
      //     parking: {
      //       id: 10,
      //       car_park_id: "52101c05-25a4-466d-887a-c43968e60970",
      //       name: "荔枝角",
      //       display_name: "東方國際大廈",
      //       district_id: 5,
      //       short_name: "GCC3",
      //       floor_plan: "",
      //       location: "荔枝角大南西街1018號東方國際大廈",
      //       location_en:
      //         "1018 Tai Nan W Street, Orient International Tower, Lai Chi Kok, KLN",
      //       image_url:
      //         "https://s3.ap-southeast-1.amazonaws.com/booking.parkingbees.com.hk/parking_cover/lai_chi_kok.jpg",
      //       map: "https://www.google.com/maps/place/%E6%9D%B1%E6%96%B9%E5%9C%8B%E9%9A%9B%E5%A4%A7%E5%BB%88/@22.3392491,114.1490637,3a,75y,7h,89.6t/data=!3m6!1e1!3m4!1snhWog6NDreOVlKxLIDFctQ!2e0!7i16384!8i8192!4m11!1m2!2m1!1z6I2U5p6d6KeS5aSn5Y2X6KW_6KGXMTAxOOiZn-adseaWueWci-mam-Wkp-W7iA!3m7!1s0x3404072ae0cd8bdf:0x50af453c0b456174!8m2!3d22.3395112!4d114.1489183!10e5!15sCi7ojZTmnp3op5LlpKfljZfopb_ooZcxMDE46Jmf5p2x5pa55ZyL6Zqb5aSn5buIkgEPYnVzaW5lc3NfY2VudGVy4AEA!16s%2Fg%2F11t2m0_zt7!5m1!1e4?coh=205409&entry=ttu&g_ep=EgoyMDI0MTAxNi4wIKXMDSoASAFQAw%3D%3D",
      //       quota: 0,
      //       cover:
      //         "https://parkingbees-global-images.s3.ap-southeast-1.amazonaws.com/lai_chi_kok.png",
      //       description: "",
      //       visible: true,
      //       deleted: false,
      //       createdAt: "2024-10-22T06:01:15.081Z",
      //       updatedAt: "2024-11-18T04:05:35.622Z",
      //       hourly_rental_weekday: 28,
      //       hourly_rental_weekend: null,
      //       hourly_rental_weekday_remark: null,
      //       hourly_rental_weekend_remark: null,
      //       daily_rental_weekday: 180,
      //       daily_rental_weekend: 130,
      //       daily_rental_weekday_remark: "星期一至五0800-19:00 (11-HR)",
      //       daily_rental_weekend_remark:
      //         "星期六、日及公眾假期 0800-19:00 (11-HR)",
      //       night_rental_weekday: 70,
      //       night_rental_weekend: null,
      //       night_rental_weekday_remark: "19:00-08:00 (13-HR)",
      //       night_rental_weekend_remark: null,
      //       gallery_images:
      //         "1731902657562.jpg,1731902669539.jpg,1731902677774.jpg,1731902687118.jpg,1731902699831.jpg,1731902713227.jpg,1731902721597.jpg,1731902730072.jpg",
      //     },
      //     availableCount: 0,
      //     totalCount: 4,
      //     estimatedWaitingTime: 2,
      //   },
      // ]);
    } catch (error) {
      console.error(error);
    } finally {
      setIsInited(true);
    }
  };

  useEffect(() => {
    fetchAllEVInfo();

    const intervalId = setInterval(
      () => {
        fetchAllEVInfo();
      },
      60 * 1000 * 3,
    ); // Update every 3 minutes

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);

  useEffect(() => {
    const prevInfo = filteredEvInfoList[selectedIndex] || {};
    const prevAvailable = prevInfo?.availableCount;
    const prevEstimate = prevInfo?.estimatedWaitingTime;

    setLoadingMap((prev) => ({
      ...prev,
      [selectedIndex]: true,
    }));

    fetchAllEVInfo().then(() => {
      const newInfo =
        filterByRegion(evInfoList, selectedRegion)[selectedIndex] || {};
      const newAvailable = newInfo?.availableCount;
      const newEstimate = newInfo?.estimatedWaitingTime;

      // 只有有變化才顯示 loading
      if (prevAvailable !== newAvailable || prevEstimate !== newEstimate) {
        setLoadingMap((prev) => ({
          ...prev,
          [selectedIndex]: true,
        }));
        setTimeout(() => {
          setLoadingMap((prev) => ({
            ...prev,
            [selectedIndex]: false,
          }));
        }, 800); // loading動畫持續時間，可調整
      } else {
        setLoadingMap((prev) => ({
          ...prev,
          [selectedIndex]: false,
        }));
      }
    });
    // eslint-disable-next-line
  }, [selectedIndex]);

  const filteredEvInfoList = Array.isArray(evInfoList)
    ? filterByRegion(evInfoList, selectedRegion) || []
    : [];

  return (
    <div className="flex laptop:hidden relative w-full max-h-[70vh]">
      {/* info section */}
      <div
        className={twMerge(
          "flex flex-col w-full gap-10 mx-0 p-5 rounded-xl bg-mainDark text-white transition-all duration-500",
          showPricing ? "opacity-50" : "opacity-100",
        )}
      >
        <div className="flex flex-row justify-between text-center">
          {REGION_LIST.map((region) => (
            <div
              key={region.key}
              className={twMerge(
                "flex flex-col",
                selectedRegion === region.key
                  ? "text-white font-bold border-b-2 border-white pb-2"
                  : "text-gray-400 cursor-pointer",
              )}
              onClick={() => {
                setSelectedRegion(region.key);
                setSelectedIndex(0);
                // scroll to top of the list
                listRef.current?.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <span className="font-bold">{region.name}</span>
              <span className="text-[10px]">{region.eng_name}</span>
            </div>
          ))}
        </div>
        <div
          className="flex flex-col gap-4 max-h-[400px] overflow-auto"
          onWheel={(e) => e.stopPropagation()}
          onTouchMove={(e) => e.stopPropagation()}
          ref={listRef}
        >
          {!isInited &&
            Array.from({ length: 3 }).map((_, idx) => (
              <div
                key={idx}
                className="flex flex-row gap-4 mx-0 p-5 rounded-xl bg-[#444] animate-pulse w-full min-h-[270px]"
              >
                <div className="flex flex-1 flex-col gap-4">
                  <div className="h-8 bg-[#666] rounded-xl mb-2" />
                  <div className="w-[92px] h-[92px] rounded-full bg-[#666]" />
                  <div className="flex flex-row gap-2">
                    <div className="w-8 h-8 bg-[#666] rounded" />
                    <div className="w-8 h-8 bg-[#666] rounded" />
                  </div>
                </div>
                <div className="flex flex-[3] flex-col gap-5">
                  <div className="h-6 bg-[#666] rounded mb-2" />
                  <div className="h-10 bg-[#666] rounded mb-2" />
                  <div className="h-6 bg-[#666] rounded mb-2" />
                </div>
              </div>
            ))}
          {isInited &&
            filteredEvInfoList.map(
              (evInfo: IParkingBeesEvChargerVacancyResponse, index: number) => {
                return (
                  <div
                    key={evInfo.ms_token}
                    className={twMerge(
                      "flex flex-row gap-4 mx-0 p-5 rounded-xl bg-[#666666] text-white w-full min-h-[270px] cursor-pointer",
                      selectedIndex === index ? "opacity-100" : "opacity-20",
                    )}
                    onClick={() => setSelectedIndex(index)}
                  >
                    {/* left */}
                    <div className="flex flex-1 flex-col gap-4">
                      <div className="font-bold text-sm rounded-xl bg-secondaryDark text-center py-1 px-2">
                        {evInfo.parking.name}
                        <br />
                        {PARKING_NAME_EN_MAP[evInfo.parking.name]}
                      </div>
                      <img
                        src={
                          evInfo.parking.id === 2
                            ? "https://parkingbees-global-images.s3.ap-southeast-1.amazonaws.com/khora_ev_cover.jpeg"
                            : evInfo.parking.cover
                        }
                        alt="address-image"
                        className="flex min-w-[92px] min-h-[92px] aspect-square rounded-full object-contain bg-black"
                      />
                      <div className="flex flex-row justify-around items-center">
                        <img
                          src={require("../../../assets/icons/free_parking_1hr.png")}
                          width={30}
                          height={70}
                          alt="free_parking_1hr"
                        />

                        <a
                          href={evInfo.parking.map}
                          target="_blank"
                          referrerPolicy="no-referrer"
                          rel="noreferrer"
                        >
                          <img
                            src={require("../../../assets/icons/locationArrow.png")}
                            width={30}
                            height={70}
                            alt="location"
                          />
                        </a>
                      </div>
                    </div>
                    {/* right */}
                    <div className="flex flex-[3] flex-col gap-5">
                      <div className="flex flex-col gap-2 border-b-2 border-secondaryDark pb-2">
                        <div>{evInfo.parking.display_name}</div>
                        <div>
                          {STATION_INFO_MAP[evInfo.parking.id]?.name_eng}
                        </div>
                      </div>

                      {evInfo.totalCount === 0 ? (
                        <div className="text-4xl text-mainYellow text-center mt-16">
                          敬請期待
                        </div>
                      ) : (
                        <>
                          <div className="flex flex-row justify-between items-end">
                            <div className="text-sm">
                              閒置中
                              <br />
                              Available
                            </div>
                            <div className="flex flex-row items-end text-secondaryDark text-4xl font-bold">
                              <span className="text-mainLightBlue text-6xl">
                                {loadingMap[index] ? (
                                  <AiOutlineLoading className="text-6xl animate-spin" />
                                ) : (
                                  <>{evInfo.availableCount}</>
                                )}
                              </span>
                              /<span>{evInfo.totalCount}</span>
                            </div>
                          </div>
                          <div className="flex flex-row justify-between items-center">
                            <div className="text-sm w-24">
                              預計等待時間
                              <br />
                              Estimated Waiting Time
                            </div>
                            <div className="text-mainLightBlue text-lg font-bold">
                              {loadingMap[index] ? (
                                <AiOutlineLoading className="text-4xl animate-spin" />
                              ) : (
                                <>~{evInfo.estimatedWaitingTime} 分鐘</>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                );
              },
            )}

          {isInited && filteredEvInfoList.length === 0 && (
            <div className="text-center text-2xl text-gray-400 h-[400px] mt-[50%]">
              即將推出
              <br />
              Coming soon
            </div>
          )}
        </div>

        <div
          className="flex flex-row gap-4 items-center text-center font-bold cursor-pointer ml-auto"
          onClick={() => {
            if (filteredEvInfoList.length === 0) return;
            setShowPricing(true);
          }}
        >
          <div>
            價目表
            <br />
            Price list
          </div>
          <LuArrowRight size={28} />
        </div>
      </div>

      {/* pricing section */}
      {filteredEvInfoList.length > 0 && (
        <div
          className={twMerge(
            "flex flex-col gap-8 py-8 rounded-xl bg-mainDark text-white absolute top-0 left-20 w-full h-full z-50 transition-transform duration-500 max-h-[70vh]",
            showPricing ? "-translate-x-20 " : "translate-x-full",
          )}
          style={{ boxShadow: showPricing ? "0 0 20px #0008" : "none" }}
        >
          <div className="flex flex-row mx-5 justify-center items-center gap-5 border-b border-white pb-8">
            <div className="flex-1 font-bold text-sm rounded-xl bg-secondaryDark text-center py-1 px-2">
              {filteredEvInfoList[selectedIndex].parking.name}
              <br />
              {
                PARKING_NAME_EN_MAP[
                  filteredEvInfoList[selectedIndex].parking.name
                ]
              }
            </div>
            <div className="flex flex-[2] flex-col gap-2">
              <div>
                {filteredEvInfoList[selectedIndex].parking.display_name}
              </div>
              <div>
                {STATION_INFO_MAP[filteredEvInfoList[selectedIndex]?.parking.id]
                  ?.name_eng ?? "-"}
              </div>
            </div>
          </div>
          <div className="flex flex-col px-10 gap-8">
            <img
              width={160}
              className="px-2"
              src={require("../../../assets/images/standard_fees.png")}
              alt="Standard Fees"
            />

            <div className="flex px-2 flex-row justify-between items-center">
              <div className="font-semibold text-xl w-[70px] text-secondaryDark">
                充電價格
                <br />
                Charging Fee
              </div>
              <div className="flex flex-col gap-2 text-right font-semibold">
                <span className="text-6xl text-mainYellow">
                  $
                  {filteredEvInfoList[selectedIndex]?.priceMin ??
                    STATION_INFO_MAP[
                      filteredEvInfoList[selectedIndex]?.parking.id
                    ]?.price}
                </span>
                <span className="text-4xl text-secondaryDark"> / kWh</span>
                <span className="text-xl">
                  {STATION_INFO_MAP[
                    filteredEvInfoList[selectedIndex]?.parking.id
                  ]?.time_period ?? "-"}
                </span>
              </div>
            </div>

            <div className="flex px-2 relative">
              <img
                src={require("../../../assets/images/bubble_desktop.png")}
                alt="bubble_d"
                className="w-full h-auto"
              />
              <div className="absolute flex flex-row text-white left-[30%] top-[18px] text-center items-baseline">
                <span className="text-base">Up to</span>
                <span className="text-2xl font-semibold ml-2">
                  {STATION_INFO_MAP[
                    filteredEvInfoList[selectedIndex]?.parking.id
                  ]?.kwh ?? "-"}{" "}
                  kW
                </span>
              </div>
            </div>
          </div>

          <div
            className="flex mx-5 items-center flex-row gap-4 text-left mt-auto font-bold cursor-pointer"
            onClick={() => setShowPricing(false)}
          >
            <LuArrowLeft size={28} />
            <div>
              返回
              <br />
              Back
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EvInfoSwiperMobile;
